module.exports = "/images/oculus-10.jpg";